import { Row } from 'antd'
import styled from 'styled-components'

import { Card as CardComp } from 'src/components/Ant'

export const Card = styled(CardComp)`
  margin-bottom: 16px;
`

export const ContainerUserAvatar = styled.a`
  display: inline-block;
  .ant-avatar {
    margin: 8px 8px 0 0;
  }
`
export const RowCustomData = styled(Row)`
  margin-top: 8px;
`
